var render = function render(_c,_vm){return _c('div',{class:_vm.$style.infoBox},_vm._l((_vm.props.items),function(item){return _c('div',{key:item.label,class:[
      _vm.$style.infoBoxText,
      item.manualProcessing ? _vm.$style.manualProcessingColor : _vm.$style.infoColor,
    ]},[_c('span',{class:item.manualProcessing
          ? _vm.$style.infoBoxTitleManual
          : _vm.$style.infoBoxTitle},[_vm._v(_vm._s(item.label))]),_vm._v(" "+_vm._s(item.content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }